export function formatNumber(number) {
  if (number === null || isNaN(number)) {
    return "0.00"; // Default value for null or invalid numbers
  }

  return number
    .toFixed(2) // Ensure two decimal places
    .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Add commas for thousands
}

export function formatAmount(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    return 'Invalid number';
  }
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B Challenge";
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M Challenge";
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K Challenge";
  }
  return num.toString();
}
